import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ACCOUNT } from '../../../../constants/routes';
import { notifyError } from '../../../../utils/Notify';
import { getCompanyForm } from './constants/companyFormList';

const FidelityForm = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (!user?._id) {
      navigate(ACCOUNT);
    } else if (!companyId) {
      notifyError('Aucun magasin choisi');
      navigate(ACCOUNT);
    } else if (!getCompanyForm(companyId)) {
      notifyError('Formulaire non disponible pour le magasin choisi');
      navigate(ACCOUNT);
    }
  }, [companyId, user, navigate]);

  if (!user?._id || !companyId) return null;

  const FormComponent = getCompanyForm(companyId);
  if (!FormComponent) return null;

  return <FormComponent companyId={companyId} {...location.state} />;
};

export default FidelityForm;
